import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import { getCurrentUser } from "../../action/user";
import SearchUser from "./SearchUser";
import Alert from "../layout/Alert";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import FormInput from "../Common/FormInputs/MuiTextField";
import AppButton from "../Common/Button/Button";
import Box from "@mui/material/Box";
import Grid2 from "@mui/material/Grid2";
import { SearchSectionLabel, SectionHeading } from "../Common/Typography/AppTypography";
import SearchIcon from "@mui/icons-material/Search";
import { selectMenuProps } from "../../utils/selectMenuProps";
import { useTheme } from "@mui/material/styles";
import { useDesignTokens } from "../../theme/useDesignTokens";

const Dashboard = ({
  getCurrentUser,
  user: { user },
  tenant: { tenantInfo },
  showDetail = false,
  allowedCountries,
}) => {
  // useEffect(() => {}, [getCurrentUser]);
  const [text, setText] = useState("");
  const [showText, setShowText] = useState(showDetail);
  const [searchBy, setSearchBy] = useState("mobile");
  const [code, setCode] = useState("91");
  const fieldHeight = 45;
  const defaultBorderColor = "rgba(0, 0, 0, 0.42)";
  const theme = useTheme();
  const { colors } = useDesignTokens();
  const primaryColor = colors?.primary?.main || theme.palette.primary.main;
  const focusOutlineSx = {
    "& .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${defaultBorderColor} !important`,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: `${primaryColor} !important`,
    },
    "& .MuiOutlinedInput-root.Mui-expanded .MuiOutlinedInput-notchedOutline, & .Mui-expanded .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(0, 0, 0, 0.42) !important",
      borderWidth: "1px",
    },
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setText("");
    if (code) {
      let searchText = text;
      if (searchBy === "mobile") {
        searchText = `+${code}${text}`;
      }
      getCurrentUser(searchText, searchBy, tenantInfo.tenantId);
      setShowText(true);
    }
  };

  const onChange = (e) => setText(e.target.value);

  const changeSearchBy = (e) => {
    setSearchBy(e.target.value);
    setText("");
    setShowText(false);
  };

  return (
    <Fragment>
      <ResponsiveContentWrapper>
        <Box sx={{ px: 0, py: 2 }}>
          <Grid2 container spacing={2}>
            <Grid2 size={12}>
                <Box
                  sx={{
                    p: 2,
                    borderRadius: 1,
                    boxShadow: 2,
                    bgcolor: "background.paper",
                  }}
                >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", sm: "auto 1fr" },
                    rowGap: 2,
                    columnGap: { xs: 2, sm: "116px" },
                    alignItems: "center",
                  }}
                >
                  <SectionHeading sx={{ mb: 0 }}>
                    Search User
                  </SectionHeading>
                  <Box
                    component="form"
                    onSubmit={onSubmit}
                    sx={{
                      display: "grid",
                      gap: 1.5,
                      gridTemplateColumns: {
                        xs: "1fr",
                        sm: "90px 200px minmax(220px, 320px) 100px",
                      },
                      alignItems: "center",
                      width: "100%",
                      justifyContent: "start",
                    }}
                  >
                    <SearchSectionLabel>Search By</SearchSectionLabel>
                    <FormInput
                      type="select"
                      size="small"
                      fullWidth
                      name="searchBy"
                      value={searchBy}
                      onChange={changeSearchBy}
                      options={[
                        { value: "mobile", label: "Mobile No" },
                        { value: "email", label: "Email Id" },
                      ]}
                      MenuProps={selectMenuProps}
                      sx={{
                        minWidth: { xs: "100%", sm: 200 },
                        maxWidth: { xs: "100%", sm: 200 },
                        "& .MuiOutlinedInput-root": { height: fieldHeight },
                        "& .MuiSelect-select": {
                          display: "flex",
                          alignItems: "center",
                          minHeight: `${fieldHeight}px !important`,
                        },
                        ...focusOutlineSx,
                      }}
                    />

                    <Box
                      sx={{
                        display: "flex",
                        gap: 0,
                        width: "100%",
                        alignItems: "stretch",
                        flexWrap: "nowrap",
                        minWidth: 0,
                        "&:focus-within .user-search-phone-wrap .react-tel-input .flag-dropdown": {
                          border: "2px solid #ff8802 !important",
                        },
                      }}
                    >
                      {searchBy === "mobile" && (
                        <Box
                          className="user-search-phone-wrap"
                          sx={{
                            width: 54,
                            height: `${fieldHeight}px`,
                            minHeight: `${fieldHeight}px`,
                            maxHeight: `${fieldHeight}px`,
                            flexShrink: 0,
                            marginRight: 0,
                            alignSelf: "stretch",
                            "& .react-tel-input": {
                              width: "100%",
                              height: `${fieldHeight}px`,
                              minHeight: `${fieldHeight}px`,
                              maxHeight: `${fieldHeight}px`,
                              margin: 0,
                            },
                            "& .react-tel-input .form-control": {
                              display: "none !important",
                              width: "0 !important",
                              minWidth: "0 !important",
                              pointerEvents: "none",
                            },
                            "& .react-tel-input .flag-dropdown": {
                              height: `${fieldHeight}px !important`,
                              minHeight: `${fieldHeight}px !important`,
                              maxHeight: `${fieldHeight}px !important`,
                              top: 0,
                              margin: 0,
                              borderRadius: "4px 0 0 4px",
                              border: `1px solid ${defaultBorderColor} !important`,
                              backgroundColor: "background.paper",
                              width: "54px",
                              boxSizing: "border-box",
                              zIndex: 2,
                              position: "relative",
                            },
                            "& .react-tel-input .flag-dropdown.open": {
                              border: "1px solid #ff8802 !important",
                            },
                            "& .react-tel-input .flag-dropdown.open .selected-flag": {
                              position: "relative",
                              zIndex: 3,
                              borderRight: "1px solid #ff8802",
                              borderBottom: "1px solid #ff8802",
                            },
                            "& .react-tel-input .country-list": {
                              marginLeft: 0,
                            },
                            "& .react-tel-input .selected-flag": {
                              height: `${fieldHeight}px`,
                              width: "54px",
                              padding: "0 0 0 10px",
                            },
                            "& .react-tel-input .selected-flag:hover": {
                              backgroundColor: "transparent !important",
                            },
                          }}
                        >
                          <PhoneInput
                            enableSearch={false}
                            value={code}
                            onChange={setCode}
                            onlyCountries={allowedCountries}
                          />
                        </Box>
                      )}

                      <FormInput
                        id="dashboard-search-value"
                        type="text"
                        fullWidth
                        size="small"
                        margin="none"
                        placeholder={
                          searchBy === "mobile"
                            ? "Mobile No Without Country Code"
                            : "Enter Email Id"
                        }
                        name="text"
                        value={text}
                        onChange={onChange}
                        startAdornment={searchBy === "email" ? <SearchIcon fontSize="small" /> : null}
                        sx={{
                          margin: 0,
                          alignSelf: "stretch",
                          "& .MuiOutlinedInput-root": {
                            height: fieldHeight,
                            minHeight: fieldHeight,
                            maxHeight: fieldHeight,
                            marginTop: 0,
                            position: "relative",
                            zIndex: 1,
                            borderTopLeftRadius: searchBy === "mobile" ? "0 !important" : undefined,
                            borderBottomLeftRadius: searchBy === "mobile" ? "0 !important" : undefined,
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: defaultBorderColor,
                            borderLeft: searchBy === "mobile" ? "none !important" : undefined,
                          },
                          /* Focus: show left border in orange to match other sides */
                          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderLeft:
                              searchBy === "mobile"
                                ? "1px solid #ff8802 !important"
                                : undefined,
                          },
                          "& .MuiInputBase-input": {
                            height: `${fieldHeight}px !important`,
                            boxSizing: "border-box",
                          },
                        }}
                      />
                    </Box>

                    <AppButton
                      type="submit"
                      variant="primary"
                      size="medium"
                      sx={{
                        minWidth: 100,
                        height: fieldHeight,
                        px: 1.5,
                        width: { xs: "100%", sm: "auto" },
                        justifySelf: { xs: "start", sm: "start" },
                      }}
                    >
                      Search
                    </AppButton>
                  </Box>
                </Box>
              </Box>
            </Grid2>
          </Grid2>
        </Box>
        <Box sx={{ px: 0 }}>
          <Alert />
          {showText && user ? <SearchUser user={user} /> : null}
        </Box>
      </ResponsiveContentWrapper>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
  tenant: state.tenant,
  allowedCountries: state.auth.allowedCountries,
});

export default connect(mapStateToProps, (dispatch) => ({
  getCurrentUser: getCurrentUser(dispatch),
}))(Dashboard);
